jQuery(document).ready(function ($) {
    var $carouselCategories = $(".box-carousel-categories .swiper");

    if (!$carouselCategories.length) return;

    $carouselCategories.each(function (index, element) {
        var mySwiper = new Swiper(element, {
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            slidesPerView: 1,
            spaceBetween: 10,
            speed: 500,
            centerInsufficientSlides: true,
            navigation: {
                nextEl: $(element).parent().find(".carousel-nav.next")[0],
                prevEl: $(element).parent().find(".carousel-nav.prev")[0],
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },

                1024: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                }
            }
        });
    });
});
